import script from "./customer-select.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-select.vue?vue&type=script&setup=true&lang=js"

import "./customer-select.vue?vue&type=style&index=0&id=5d519c14&lang=scss&scoped=true"
import "./customer-select.vue?vue&type=style&index=1&id=5d519c14&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d519c14"]])

export default __exports__